import { render, staticRenderFns } from "./ReusePotentialIndexDetailsDialog.vue?vue&type=template&id=fef9b368&scoped=true"
import script from "./ReusePotentialIndexDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ReusePotentialIndexDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef9b368",
  null
  
)

export default component.exports